import { createSelector } from '@ngrx/store';
import { BoelsState } from '../../reducers.index';
import { CartState } from '../reducers/cart.reducer';
import * as fromFeature from '../../reducers.index';

export const selectCartState = createSelector(
  fromFeature.getStoreState,
  (state: BoelsState) => state.cart,
);

export const selectCartItems = createSelector(
  selectCartState,
  (state: CartState) => state.entries,
);

export const selectCartLoading = createSelector(
  selectCartState,
  (state: CartState) => state.loading,
);

export const selectActiveCartId = createSelector(
  selectCartState,
  (state: CartState) => state.active,
);

export const selectActiveCart = createSelector(
  selectCartState,
  (state: CartState) => state.entries[state.active],
);

export const selectActiveCheckoutStepNumber = createSelector(
  selectCartState,
  (state: CartState) => state.checkoutStepNumber,
);

export const selectModifiedCart = createSelector(
  selectCartState,
  (state: CartState) => state.cartModifications,
);

export const selectOrder = createSelector(
  selectCartState,
  (state: CartState) => state.order,
);

export const selectCheckoutAccount = createSelector(
  selectCartState,
  (state: CartState) => state.checkoutAccount,
);
